import { Page } from "@tfg/ui"
import { useTranslation } from "react-i18next"

export const FAQWrapper = () => {
  const { t } = useTranslation("faq")

  return <Page title={t("title")} />
}
